export const getStaffPiiConfig = () => {
  return staffPiiConfig
}

const staffPiiConfig = [
  {
    id: 'name',
    type: 'TEXT',
    placeholder: 'Add clinician name',
    label: 'Name',
    postfix: '*',
    value: '',
    validation: { required: true },
    errorMsg: 'Name is required',
  },
  {
    id: 'phone',
    type: 'PHONE',
    placeholder: 'Add clinician phone number',
    label: 'Phone number',
    postfix: '*',
    value: '',
    validation: {
      validate: (value) => {
        if (!value.tel && !value.countryCode) {
          return 'This is required.'
        }

        if (!value.tel) {
          return 'Phone number is required.'
        }
        if (!value.countryCode) {
          return 'Country code is required.'
        }

        return value || 'This is required.'
      },
    },
    errorMsg: 'Phone number required',
    disabled: false,
  },
  {
    id: 'email',
    type: 'TEXT',
    placeholder: 'Add clinician email',
    label: 'Email',
    postfix: '*',
    value: '',
    validation: { required: true },
    errorMsg: 'Email required',
    disabled: false,
  },
]
